import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AuthEffects, authOtpReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([AuthEffects]), StoreModule.forFeature(`otp`, authOtpReducer)]
})
export class AuthOtpStateModule {}
